import Vue from 'vue'
import Vuex from 'vuex'
import https from '../https.js' 　

Vue.use(Vuex)

const store=new Vuex.Store({
    state:{
        title1:"",//临床营养实习带教平台
        title2:"",
        totleIsShow:false,//控制footer下的资料数量是否显示

        //首页home数据
        imgList:"",    //轮播
        ziyuanList:"",
        pageview:0,//页面访问量


        //二级页面list数据
        category_id:"",  //一级页面跳转到二级传递的id,三级界面跳转到二级界面传递的id
        selected:1,      //tab选项，默认选1
        videoTabHeight:"",
        videoMsg:"",

        //二级页面list的tab列表数据
        defList:[],//默认列表(准备)
        page1:1,
        isShow1:false,
        twoList:[],//列表(正文)
        page2:1,
        isShow2:false,
        threeList:[],//列表(视频)
        page3:1,
        isShow3:false,
        fourList:[],//列表(拓展)
        page4:1,
        isShow4:false,
        tabar:"",
        tabCount:"",



        //footer组件数据
        beianMsg:"",
        
        //back组件数据
        //n:0,   //pdf比较特殊，页面第一次加载pdf返回一次，之后会返回两次
        token: localStorage.getItem('token'),
        userInfo:{},
        pdfDefault:'https://book-new.oss-cn-beijing.aliyuncs.com/static/share_def.png',
        linkDefault:'https://book-new.oss-cn-beijing.aliyuncs.com/static/share_link.png',
        shareDefault:'https://book-new.oss-cn-beijing.aliyuncs.com/static/share_def.png'
    },
    getters:{//类似computed属性

    },
    mutations:{
        
        //一级页面
        getMsg(state){
            // 获取广告列表
             https.fetchPost("slides/index",{})
                  .then(result=>{
                    state.imgList=result.data.data;
                  })  
            // 获取分类列表
            let parentNav=https.getQueryString('parent_id')
            let lanmuNav=https.getQueryString('id')
            https.fetchPost("Article/getCategoryList",{})
                  .then(result=>{
                    let res=result.data.data.list
                    for(let item of res){
                        item.isCheck=parentNav=='0'&&item.id==lanmuNav?true:false
                        for(let items of item.children){
                            items.isCheck=parentNav!='0'&&items.id==lanmuNav?true:false
                            if(items.isCheck){
                                item.isCheck=true
                            }
                            
                        }
                    }
                    state.ziyuanList=res;
                    //首页访问量
                    state.pageview=result.data.data.count;
                  })  
        },
        getBeian(state){
            // 获取footer信息
            https.fetchPost("Article/getBeiAnInfo",{})
            .then(result=>{
                state.beianMsg=result.data.data;
                let siteName=result.data.data.site_name?result.data.data.site_name: '临床营养实习带教平台'
                document.title=siteName;
                state.title1=siteName;
                state.title2=siteName;
            })  
        },
        RESET_INFO(state) {
            state.token=''
            state.userInfo='';
          },
          SET_LOGIN(state,info) {
            state.token=info.token
            state.userInfo=info.user
          },
          SET_VIDEOMSG(state,info){
            state.videoMsg=info
          }
        
        
    },
    actions:{
        
        setIntUrl({ commit}){
            if(localStorage.getItem('iniUrl')){

            }else{
                let url=window.location.href
                 localStorage.setItem('iniUrl',url)
            }
            
        },
        resetIntUrl({ commit}){
            localStorage.removeItem('iniUrl')
        },
        setLoginInfo({ commit},info){
            localStorage.setItem('token',info.token)
            localStorage.setItem('userInfo',JSON.stringify(info))
            commit('SET_LOGIN',info);
        },
        resetLogin({ commit, state }) {
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
            commit('RESET_INFO');
        },
        setNavRoute(){
            let urlw=localStorage.getItem('iniUrl')?localStorage.getItem('iniUrl'):window.location.origin+'#/home'
            var path1=urlw.split('#/')[0];
            var parm=urlw.split('#/')[1];
            var path;
            if(parm.indexOf('?')==-1){
                path=parm==''?path1+'#/home':urlw;
            }else{
                var parm2=parm.split('?')[0];
                path=parm2==''?path1+'#/'+'home'+parm:urlw;
            }

            //todo new 2023-6-5 start
            if(!path || path.indexOf('#/auth')!=-1){
                let tmp_url=window.location.href;
                path = tmp_url.split('#/')[0];
            }
            //todo new 2023-6-5 end

            window.location.replace(path)
            localStorage.removeItem('iniUrl')

            /*try{
                //todo new 20260212 优化
                // 1. 获取目标路由
                let targetRoute = localStorage.getItem('iniUrl') || '/home';

                // 2. 如果存的是完整URL，提取路由部分
                if (targetRoute.includes('#/')) {
                    targetRoute = targetRoute.split('#/')[1];
                }

                // 3. 清理 iniUrl
                localStorage.removeItem('iniUrl');

                // 4. 使用 Vue Router 跳转
                this.$router.push(targetRoute).catch(err => {
                    // 如果跳转失败（比如路径不存在），跳转到首页
                    console.warn('跳转失败，目标路由:', targetRoute, '错误:', err);
                    this.$router.push('/home');
                });
            }catch (err) {
                console.error('路由跳转异常：', err);
                this.$router.push('/home');
            }*/
        },
        setLoginStus({ commit, state },info) {
            localStorage.setItem('loginStus',info)
        },
        resetLoginStus({ commit, state }) {
            localStorage.removeItem('loginStus')
        },
        async toLoginOut(){
            const result=await https.fetchPost("Login/logout",{})
            return result.data
        },
        async searchFn({ commit, state },info){
            const result=await https.fetchPost("Article/index",info)
            return result.data
        },
        async addCollects({ commit, state },info){
            const result=await https.fetchPost('Favorite/add',info)
            return result.data
        },
        async gethistorys({commit, state}, info) {
            const result=await https.fetchPost("Readrecord/index",info)
            return result.data
        },
        async getCollects({commit, state}, info) {
            const result=await https.fetchPost("Favorite/index",info)
            return result.data
        },
        async deletCollects({commit, state}, info) {
            const result = await https.fetchPost("Favorite/delete",info)
            return result.data
        },
        async deletHistorys({commit, state}, info) {
            const result =await https.fetchPost("Readrecord/delete",info)
            return result.data
        },
        async getSend({commit, state}, info) {
            const result =await https.fetchPost("Login/getLoginSmsCode",info)
            return result.data
        },
        async getSendBind({commit, state}, info) {
            const result =await https.fetchPost("Login/getBindingSmsCode",info)
            return result.data
        },
        async authSitOpens({commit, state}, info) {
            const result =await https.fetchPost("Wechat/getWxUserInfo",info)
            return result.data
        },
        async bingingTel({commit, state}, info) {
            const result =await https.fetchPost("Login/bindingMobile",info)
            return result.data
        },
        async toLogin({commit, state}, info) {
            const result =await https.fetchPost("Login/smsLogin",info)
            return result.data
        },
        async getArticals({commit, state}, info) {
            const result =await https.fetchPost("Article/index",info)
            return result.data
        },
        setVideoMsg({commit, state}, info) {
            commit('SET_VIDEOMSG',info)
        },
        // todo new 20260205 新增：密码登录 start
        async toLoginByPwd({ commit }, info) {
            const result =await https.fetchPost("Login/pwdLogin",info)
            return result.data
        },
        //重置密码
        async modifyPwd({ commit }, info) {
            const result =await https.fetchPost("Login/passwordReset",info)
            return result.data
        },
        // todo new 20260205 新增：密码登录 end
        
        
      
    }
})

export default store  //导出


// WEBPACK FOOTER //
// ./src/store/index.js